import React from "react";
import "./Teste.css";

const Teste = () => {
    return (
        <div className="teste-page">
            <div className="receipt-card">
                <div className="status-icon" aria-hidden="true">
                    <svg viewBox="0 0 120 120" className="status-glow">
                        <defs>
                            <linearGradient id="ring" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#7df0b3" />
                                <stop offset="100%" stopColor="#4bdca0" />
                            </linearGradient>
                        </defs>
                        <circle cx="60" cy="60" r="44" fill="none" stroke="url(#ring)" strokeWidth="8" />
                        <path
                            d="M44 61.5l10.5 10.5L77 49.5"
                            fill="none"
                            stroke="url(#ring)"
                            strokeWidth="9"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                <div className="receipt-title">Pagamento Concluido!</div>
                <div className="receipt-amount">R$ 150,00</div>

                <div className="receipt-details">
                    <div className="detail-row">
                        <span className="detail-label">Para:</span>
                        <span className="detail-value">Loja Exemplo Ltda.</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Data:</span>
                        <span className="detail-value">24 Mai, 15:30</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Metodo:</span>
                        <span className="detail-value">Card ending 4589</span>
                        <span className="detail-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24">
                                <rect x="2" y="5" width="20" height="14" rx="3" />
                                <rect x="4.5" y="9" width="15" height="2.6" rx="1" />
                                <rect x="5.5" y="14" width="6" height="2" rx="1" />
                            </svg>
                        </span>
                    </div>
                </div>

                <button className="btn-primary" type="button">
                    Conclundo
                </button>
                <button className="btn-outline" type="button">
                    <span className="btn-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24">
                            <circle cx="6" cy="12" r="2.2" />
                            <circle cx="18" cy="6" r="2.2" />
                            <circle cx="18" cy="18" r="2.2" />
                            <path d="M7.9 11l7-4" />
                            <path d="M7.9 13l7 4" />
                        </svg>
                    </span>
                    Compartilhar Comprovante
                </button>
            </div>
        </div>
    );
};

export default Teste;
